import palette from 'constants/palette'
import React from 'react'

type Props = {
  className?: string
  fillColor?: string
}

// Mouse-pointer glyph for the Live Updates Overview "how it works" demo.
const Cursor = ({ className, fillColor = palette.grey90 }: Props) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill={fillColor}
    stroke={palette.white}
    strokeWidth="1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 3l14 8-6 1.5L10 20 5 3z" />
  </svg>
)

export default Cursor
